import React from 'react';
import classNames from 'classnames';
import useSheet from 'app/jss';

type Props = {
  classes: object,
  children: any,
  className?: string,
  children?: any,
};


class GroupDetailsTitle extends React.Component {
  props: Props;

  static defaultProps = {
    className: undefined,
    children: undefined,
  };

  render() {
    const {
      classes,
      className,
      children,
    } = this.props;
    return (
      <div className={classNames(classes.title, className)}>
        {children}
      </div>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    title: {
      fontSize: 18,
      width: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textAlign: 'right',
      fontWeight: 600,
      textTransform: 'uppercase',
      zIndex: 1,
    },
  };
}

export default useSheet(applyStyles)(GroupDetailsTitle);
